const state = {
  wonAuctionsState: null,
};

const getters = {
  wonAuctionsState: (myAcvState) => myAcvState.wonAuctionsState,
};

const mutations = {
  SET_WON_AUCTIONS_STATE(myAcvState, payload) {
    // eslint-disable-next-line no-param-reassign
    myAcvState.wonAuctionsState = payload;
  },
  CLEAR_WON_AUCTIONS_STATE(myAcvState) {
    // eslint-disable-next-line no-param-reassign
    myAcvState.wonAuctionsState = null;
  },
};

const actions = {
  setWonAuctionsState({ commit }, wonState) {
    commit('SET_WON_AUCTIONS_STATE', wonState);
  },
  clearWonAuctionsState({ commit }) {
    commit('CLEAR_WON_AUCTIONS_STATE');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
